import styled from "styled-components";
import { theme } from "./theme";

export const StyledButton = styled.button`
	text-transform: ${({ initial }) => (initial ? "initial" : "uppercase")};
	color: ${theme.color.green};
	border-radius: 2.5rem;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: ${(props) => (props.small ? "0" : "1.6rem 2rem")};
	border: none;
	font-size: 1.2rem;
	font-family: ${theme.font.secondary};
	font-weight: 500;
	box-shadow: ${(props) => (props.bg ? "0 0.3rem 0.6rem rgba(0, 0, 0, 0.16)" : "none")};
	background: ${(props) => (props.bg ? theme.color.white : "transparent")};
	height: ${(props) => (props.small ? "auto" : "5rem")};
	cursor: pointer;
	line-height: 100%;
	-webkit-appearance: button;
	width: auto;
	min-width: ${(props) => (props.small ? "auto" : "12rem")};
	transition: box-shadow 0.2s ease-in-out;
	white-space: nowrap;
	img {
		margin-right: 0.6rem;
	}
	&:disabled {
		cursor: not-allowed;
	}
	&:hover {
		box-shadow: ${(props) => (props.bg ? "0 0.3rem 0.6rem rgba(0, 0, 0, 0.4)" : "none")};
	}
	span {
		text-decoration: none;
	}
`;
